<template>
  <div class="phone">
    <div v-if="friends">
      <!-- Primary header -->
      <header-vue
        :add-new="addNew"
        :hide-new="hideNew"
        :additional="additional"
        :show="showList"
        :update-show="updateShow"
      />

      <transition name="swipe" mode="out-in">
        <!-- Add new -->
        <add-new v-if="addNew" :show="showList" />

        <!-- Section -->
        <section-vue :show="showList" v-else />
      </transition>
    </div>

    <!-- Loader -->
    <div class="loader-container" v-else>
      <loader-vue />
    </div>
  </div>
</template>

<script>
import HeaderVue from "./Header.vue";
import LoaderVue from "../../Appointment/common/Loader.vue";
import SectionVue from "./Section.vue";
import AddNew from "./AddNew";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { authMixin } from "../../../mixins/authMixin";
import { permissionMixin } from "../../../mixins/permissionMixin";

export default {
  mixins: [authMixin, permissionMixin],
  data() {
    return {
      showList: "all",
      addNew: false,
      addNewIcon: require("../../../assets/svg/add-chat-bg-fill.svg")
    };
  },
  components: {
    HeaderVue,
    SectionVue,
    LoaderVue,
    AddNew
  },
  computed: {
    ...mapGetters("chat", {
      friends: "getFriends"
    }),
    ...mapGetters({
      userRole: "getUserRole"
    }),
    additional() {
      return {
        click: this.handleAddNewClick
      };
    }
  },
  methods: {
    ...mapActions("chat", {
      getDetails: "getDetails"
    }),
    ...mapMutations({
      setSearchValue: "setSearchValue"
    }),
    ...mapActions({
      getFormDetails: "getFormDetails"
    }),
    hideNew() {
      this.addNew = false;
    },
    handleAddNewClick() {
      if (this.userRole === 25 || this.userRole === 22) {
        this.$router.push("/messenger");
      } else {
        this.addNew = !this.addNew;
      }
    },
    updateShow(value) {
      this.showList = value;
    }
  },
  async created() {
    this.setSearchValue(""); // TO remove the search text
    if (this.checkIfNotPortalUser) {
      return await Promise.all([this.getFormDetails(), this.getDetails()]);
    }
    this.getDetails();
  }
};
</script>

<style scoped>
section {
  margin-top: 126px;
}

.add-new-icon {
  width: 35px;
  height: 35px;
}

.heading-end {
  cursor: pointer;
}

span.fill {
  flex-grow: 1;
}

.heading .heading-end {
  position: fixed;
  top: 54px;
  right: 14px;
  z-index: 9999;
}

.swipe-enter-active {
  animation: swipeIn 0.2s ease-in-out;
}

.swipe-leave-active {
  animation: swipeOut 0.2s ease-in-out;
}

.swipe-move {
  transition: all 0.2s ease-in-out;
}

@keyframes swipeIn {
  from {
    opacity: 0;
    transform: translateX(-100px);
  }

  50% {
    opacity: 0.5;
    transform: translateX(-50px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes swipeOut {
  from {
    opacity: 1;
    transform: translateX(0);
  }

  50% {
    opacity: 0.5;
    transform: translateX(-50px);
  }

  to {
    opacity: 0;
    transform: translateX(-100px);
  }
}
</style>
